import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const userActGrid = createAsyncThunk(
    'user-acc-grid',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetAppUserList`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const searchUserActGrid = createAsyncThunk(
    'search-user-acc-grid',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetAppUserList`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const addUser = createAsyncThunk(
    'add-user',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/CreateUser`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const changePass = createAsyncThunk(
    'change-password',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/UpdateUserPassword`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const changeUserStatus = createAsyncThunk(
    'change-user-status',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/SwitchUserStatus`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const userServiceList = createAsyncThunk(
    'user-servicfe-list',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetAppUserServiceList/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const serviceExceptionList = createAsyncThunk(
    'user-service-exception',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetUserServiceException/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const addServiceException = createAsyncThunk(
    'user-service-addexception',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/AddUserServiceException`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);

export const removeServiceException = createAsyncThunk(
    'user-service-removeexception',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/DeleteUserServiceException/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const subscribedProduct = createAsyncThunk(
    'subscribed-products',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetEntSubscribedProdMap/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

export const assocOtherProducts = createAsyncThunk(
    'associated-other-products',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetAppUserInfo/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);

// Entitlement/GetEntSubscribedProdMap/30841/1080,Entitlement/GetAppUserInfo/30841

// export const associateProducts = createAsyncThunk(
//     'associate-products',
//     async (payload,{rejectWithValue})=>{
//         try{
//             const {data} = await axios.post(
//                 `${backendURL}Entitlement/UpdateUserPassword`,
//                 payload,
//                { headers:authHeader()}
//             );
//             return data;
//         }catch(error){
//             if(error.response && error.response.data){
//                 return rejectWithValue(error.response.data)
//             }else{
//                 return rejectWithValue(error.response.data)
//             }
//         }
//     }
// );

// export const mapOtherProduct = createAsyncThunk(
//     'map-with-other-product',
//     async (payload,{rejectWithValue})=>{
//         try{
//             const {data} = await axios.post(
//                 `${backendURL}Entitlement/UpdateUserPassword`,
//                 payload,
//                { headers:authHeader()}
//             );
//             return data;
//         }catch(error){
//             if(error.response && error.response.data){
//                 return rejectWithValue(error.response.data)
//             }else{
//                 return rejectWithValue(error.response.data)
//             }
//         }
//     }
// );


// https://v2dev-api.kogaruda.com/api/Auth/userprofile/30841,CreateUser,UpdateUserPassword